const styles = ({ COLORS }) => ({
  container: {
    background: '#fafafa',
    borderBottom: '2px solid #eee',
    padding: '20px'
  },
  actions: {
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '35px'
  },
  uploader: {
    display: 'flex',
    alignItems: 'center',
    padding: '7px 6px'
  },
  upload: {
    cursor: 'pointer',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    color: COLORS.BLUE.NORMAL,
    '&:hover': {
      color: COLORS.BLUE.FADED
    },
    '& > svg': {
      marginRight: '4px'
    }
  },
  uploadDisabled: {
    color: '#cbcbcb',
    cursor: 'default',
    '&:hover': {
      color: '#cbcbcb'
    }
  },
  uploadReady: {
    background: COLORS.BLUE.NORMAL,
    borderRadius: '4px',
    '& span': {
      color: '#fff !important'
    }
  },
  textarea: {
    height: '100px',
    resize: 'none'
  },
  cancel: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'opacity 300ms ease-in-out'
  },
  visible: {
    visibility: 'visible',
    opacity: 1
  },
  area: {
    display: 'flex'
  },
  avatar: {
    fontSize: '25px',
    flexShrink: 0,
    marginRight: '10px'
  },
  templates: {
    display: 'flex',
    padding: '0 35px',
    justifyContent: 'flex-start',
    listStyle: 'none',
    margin: '10px 0 0',
    overflowX: 'auto'
  },
  template: {
    maxWidth: '30%',
    padding: '10px',
    border: '1px dashed #aaa',
    borderRadius: '4px',
    marginRight: '10px',
    color: '#aaa',
    cursor: 'pointer',
    minWidth: '170px',
    '&:hover': {
      background: '#fff',
      color: '#555',
      borderColor: COLORS.BLUE.NORMAL
    }
  },
  thumbnail: {
    minWidth: '145px',
    marginRight: '10px',
    cursor: 'pointer',
    '& > div': {
      display: 'block',
      position: 'relative',
      background: '#ececec',
      width: '100%',
      //paddingBottom: '133%',
      paddingBottom: '70%',
      borderRadius: '8px',
      border: '2px solid transparent',
      overflow: 'hidden',
      '& > span': {
        position: 'absolute',
        left: '0',
        top: '0',
        backgroundSize: 'cover',
        width: '100%',
        height: '100%',
        color: '#fff',
        textAlign: 'right',
        paddingRight: '5px',
        paddingTop: '5px',
        fontWeight: 'bold',
        textShadow: '0px 0px 3px black'
      },
      '& > span > strong': {
        background: '#555555b0',
        padding: '2px 4px',
        borderRadius: '4px'
      }
    }
  },
  selected: {
    '& > div': {
      borderColor: COLORS.BLUE.NORMAL
    }
  }
})

export default styles
